// Enforce hash-routing redirect for pathname-based SSO logins from Siakad
if (window.location.pathname === '/sso-login' || window.location.pathname.includes('/sso-login')) {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  if (token) {
    window.location.href = `/#/sso-login?token=${token}`;
  }
}

import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './assets/index.css';
import './assets/icons'; // semua icon ngumpul di sini
import { createPinia } from 'pinia';

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { LocalNotifications } from '@capacitor/local-notifications';

import 'register-service-worker';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { App as CapacitorApp } from '@capacitor/app';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const isNative = Capacitor.isNativePlatform()

if (isNative) {
  LocalNotifications.requestPermissions();
}

CapacitorApp.addListener('appUrlOpen', async (data) => {
  console.log('DEEPLINK MASUK:', data.url);

  if (data.url.startsWith('garapedu://payment-success')) {
    await Browser.close();
  }

  if (data.url.startsWith('garapedu://bill-payment-success')) {
    await Browser.close();
  }
});

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(store)
  .use(router)
  .use(pinia)
  .mount('#app');
